module.exports = __webpack_public_path__ + "static/img/P8.58adfcee.png";